(function () {
  'use strict';
  var lang = document.documentElement.lang || 'en';
  var local, utc;
  try {
    local = new Intl.DateTimeFormat(lang, {dateStyle: 'long'});
    utc = new Intl.DateTimeFormat(lang, {dateStyle: 'long', timeZone: 'UTC'});
  } catch (e) {}
  document.querySelectorAll('time[data-d], time[data-localize][datetime]').forEach(function (el) {
    var date, formatter = local;
    if (el.hasAttribute('data-d')) {
      var days = Number(el.getAttribute('data-d'));
      if (!Number.isFinite(days)) return;
      date = new Date();
      date.setDate(date.getDate() + days);
    } else {
      var value = el.getAttribute('datetime');
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        date = new Date(value + 'T12:00:00Z');
        formatter = utc;
      } else date = new Date(value);
    }
    if (formatter && !Number.isNaN(date.getTime())) el.textContent = formatter.format(date);
  });
  document.querySelectorAll('[data-mb-order]').forEach(function (root) {
    var script = root.querySelector('[data-mb-variants]'), variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    function update() {
      var size = root.querySelector('[name=size]:checked');
      var cover = root.querySelector('[name=cover]:checked');
      if (!size || !cover) return;
      var edition = variants.find(function (v) { return v.size === size.value && v.cover === cover.value; });
      if (!edition) return;
      var card = root.querySelector('[data-mb-your-edition]');
      card.querySelector('h3').textContent = edition.name;
      card.querySelector('[data-mb-spec]').textContent = edition.spec;
      card.querySelector('[data-mb-member]').textContent = edition.member;
      card.querySelector('[data-mb-normal]').textContent = edition.normal;
      card.querySelector('[name=id]').value = edition.id || '';
      card.querySelector('button[type=submit]').disabled = !edition.id;
    }
    root.addEventListener('change', update);
    update();
  });
  document.querySelectorAll('.lib-sample').forEach(function (root) {
    var audio = root.querySelector('[data-sample]'), button = root.querySelector('[data-sample-play]');
    if (!audio || !button) return;
    function state() { button.setAttribute('aria-pressed', String(!audio.paused)); }
    button.addEventListener('click', function () {
      if (audio.paused) {
        document.querySelectorAll('audio[data-sample]').forEach(function (other) { if (other !== audio) other.pause(); });
        var promise = audio.play();
        if (promise) promise.catch(state);
      } else audio.pause();
    });
    audio.addEventListener('play', state);
    audio.addEventListener('pause', state);
    audio.addEventListener('ended', state);
    audio.addEventListener('timeupdate', function () {
      var fill = root.querySelector('[data-sample-fill]'), time = root.querySelector('[data-sample-time]');
      if (fill && audio.duration) fill.style.inlineSize = Math.min(100, audio.currentTime / audio.duration * 100) + '%';
      if (time) time.textContent = Math.floor(audio.currentTime / 60) + ':' + String(Math.floor(audio.currentTime % 60)).padStart(2, '0');
    });
  });
}());
